'use strict';
require('../../modules/es.array-buffer.constructor');
require('../../modules/es.array-buffer.slice');
require('../../modules/es.typed-array.uint8-array');
require('./methods');
var global = require('../../internals/global-this');

module.exports = global.Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/es/typed-array/uint8-array.js
// module id = 335
// module chunks = 0